import { ContentfulBenefitsAdditional } from 'ContentfulDefaults/types/benefitsAdditional';

export const benefitsAdditional: {
  benefits_section_additional: ContentfulBenefitsAdditional;
} = {
  benefits_section_additional: {
    accessibility: {
      collapse_benefit_details: 'Hide {x} Details',
      expand_benefit_details: 'Show More {x} Details',
    },
    best_match_badge_label: 'Great Fit',
    coverage_details_header: 'Coverage Details',
    coverage_level_table_header: 'Coverage levels',
    coverage_level_table_subheader: 'You can select your preferred amounts when you go to enroll.',
    coverage_options_auto_enrolled_label: 'Select who you would be adding additional coverage for.',
    coverage_options_label: 'First, select who you are covering in a {x} plan.',
    covered_conditions_table_header: 'Covered conditions',
    covered_conditions_table_subheader: 'Here are the conditions that trigger a payout on this plan.',
    custom_messages: [],
    deductible: 'Deductible',
    enrollee_select_disclaimer: {
      contentful_name: 'Enrollee Select Disclaimer',
      color: 'blue',
      text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'For certain benefits below, you may check or uncheck enrollees to see the rates for your selection.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
    },
    fbs_plan_auto_enrolled_info_bar: {
      contentful_name: '[Benefit Details] Fbs Plan Auto Enrolled Info Bar',
      text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'Your employer offers this plan to you at no cost!',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      color: 'blue',
    },
    fbs_plan_auto_enrolled_label: 'Optionally, choose additional {x} coverage below.',
    fbs_plan_buy_up_info_bar: {
      contentful_name: '[Benefit Details] Fbs Plan Buy Up Info Bar',
      text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'You may elect to purchase additional coverage below which provides benefits beyond this auto-enrolled plan.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      color: 'blue',
    },
    fbs_plan_label: 'Select your coverage.',
    id_theft_benefit: {
      contentful_name: 'Id Theft Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/legal_services.svg',
      card_title: 'ID Theft',
      card_description:
        'Identity theft protection benefits protect you from ID theft and help you recover if you become a victim of ID theft.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'ID Theft Protection Benefits help block criminals by monitoring the internet for suspicious activity related to your credit and other accounts, and sending you alerts when they notice suspicious activity. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'These benefits can also help you mitigate the harm from ID theft if it does occur, by providing access to advocates who can help you through the time consuming and stressful process of reversing damages from ID theft. Some benefits also include insurance to help you cover costs associated with ID theft, such as lost wages, legal fees, or direct reimbursement of stolen funds. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'The specific benefits available to you may vary, so be sure to carefully review your plan details. ',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [{ data: {}, marks: [], value: '\n', nodeType: 'text' }],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/748110370',
    },
    in_network: 'IN-NETWORK',
    network_info_header: 'Network Info',
    network_name: 'Network Name',
    no_plans_info_bar: {
      contentful_name: '[BenefitDetails] No Plans Info Bar',
      text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'Unlike other benefits with "Choose" buttons, there are no plans to choose from here.  Learn more about how this benefit works below.',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
    },
    non_selectable_plans_label: 'Learn more about this service your employer offers:',
    number_with_pay_period_range_label: 'starting at',
    other_benefit: {
      contentful_name: 'Other Benefit',
      card_title: 'Other Benefits',
      card_description: 'Additional supplemental benefits offered by your employer',
      custom_module_benefit: 'Additional supplemental benefit offered by your employer',
    },
    cancer_benefit: {
      contentful_name: 'Cancer Benefit',
      icon_link:
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/critical-illness.svg',
      card_title: 'Cancer Insurance',
      benefit_page_title: 'Cancer Insurance',
      card_description:
        'Cancer insurance provides financial protection in case you’re diagnosed with cancer.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'More than one in three Americans are expected to get cancer in their lifetimes. While that’s certainly not a fun statistic, more and more people are also surviving cancer thanks to advances in modern medicine.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  "But fighting cancer is expensive. Medical insurance covers a lot of treatment costs, but you'd almost certainly hit your out-of-pocket maximum for the year. Not to mention the costs of traveling to appointments, lost income from time off work, and all of your usual everyday expenses. That’s where cancer insurance can help.",
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'If you’re diagnosed with a covered cancer, this type of policy sends you a check that you can use to help cover medical expenses or spend on anything you like. You may also receive additional payments based on the type of treatment you need or even for getting certain preventive care without a diagnosis.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'Important to note: Cancer insurance won’t cover any illness diagnosed before you enroll in a policy. So if you’re thinking of getting this coverage, sooner is probably better.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  'These policies also won’t pay benefits for any cancer-related illness you develop over the course of treatment and may include restrictions if you have a recurrence of a previous cancer. Check your plan docs for the details.',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    life_ltc_benefit: {
      contentful_name: '[default] Life Ltc Benefit',
      icon_link: '',
      card_title: 'Life + Long-Term Care',
      benefit_page_title: 'Life + Long-Term Care',
      card_description:
        'By purchasing a group policy through your employer, you may be able to get a better rate than you would on your own.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'Life and long-term care insurance is a type of hybrid plan that allows you to have permanent life insurance and extra coverage for your long-term care needs, if and when you get there.',
                marks: [],
                data: {},
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'This includes the cost of care in your home or elsewhere, like at a nursing home, an assisted living facility, or an adult daycare center.',
                marks: [],
                data: {},
              },
            ],
          },
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'As long as you keep the plan, your monthly premiums won’t increase, regardless of your age, health, or whatever’s happening in the economy. When you pass away, your loved ones get a payout. Or, if you change your mind, you can cancel the plan and keep its cash value.',
                marks: [],
                data: {},
              },
            ],
          },
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'With most policies, you’ll become eligible to start making claims on your plan when you can’t do at least two out of six activities of daily living (ADLs) on your own. The official list of ADLs is:',
                marks: [],
                data: {},
              },
            ],
          },
          {
            nodeType: 'unordered-list',
            data: {},
            content: [
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [{ nodeType: 'text', value: 'Bathing', marks: [], data: {} }],
                  },
                ],
              },
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [{ nodeType: 'text', value: 'Dressing', marks: [], data: {} }],
                  },
                ],
              },
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [{ nodeType: 'text', value: 'Eating', marks: [], data: {} }],
                  },
                ],
              },
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [{ nodeType: 'text', value: 'Caring for incontinence', marks: [], data: {} }],
                  },
                ],
              },
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                      { nodeType: 'text', value: 'Getting on or off the toilet', marks: [], data: {} },
                    ],
                  },
                ],
              },
              {
                nodeType: 'list-item',
                data: {},
                content: [
                  {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                      {
                        nodeType: 'text',
                        value: 'Transferring in or out of bed or a chair',
                        marks: [],
                        data: {},
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'You may also be eligible if you have dementia or another cognitive impairment. Be sure to check your plan documents for details.',
                marks: [],
                data: {},
              },
            ],
          },
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value:
                  'Note: You may also have access to a state-sponsored long-term care plan, depending on where you live and work.',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
    },
    page_header: {
      text: 'Choose Your Benefits',
      subtext: 'Your employer offers these voluntary supplemental benefits.',
    },
    provider_link: 'Find a provider',
    provider_directory: 'Provider Directory',
    recommended_badge_label: 'Good Fit',
    supplemental_plans: [
      {
        plan_id: '12345',
        benefit_items: ['Broken Toe:$2,000 minimum benefit', 'Broken Hip:$5,000 maximum benefit'],
        carrier: 'carrier',
        contentful_name: '[test-go] Plan - Accident - 735005',
        coverage_disclaimer:
          'Accident coverage is available for spouses and children. Kids may be covered until age 22.',
      },
    ],
    text_note: {
      short_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'text note short text',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      long_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'long text text note',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      button_text: 'Read More',
    },
    tooltips: {
      max_annual_benefit: {
        title: 'Maximum Annual Benefit',
        text: 'This is the maximum amount that your plan will cover for dental services in a year.',
      },
      recommended_badge:
        'This type of benefit is a great option for you! Click "Learn More" or "Choose" to see why we recommend it.',
      best_match_badge:
        'Of the voluntary benefits available to you, we think that this is your best match! Click on the "Learn More" button to see why we recommend it.',
    },
    coverage_disclaimer_available_to_all:
      '{plan} insurance is available for all family members. Kids may be covered until age {maxAge}.',
    coverage_disclaimer_available_to_none: '{plan} insurance is not available for family members.',
    coverage_disclaimer_available_to_spouses: 'Not all family members are eligible for this benefit.',
    coverage_disclaimer_available_to_children: 'Not all family members are eligible for this benefit.',
    coverage_disclaimer_available_to_partners:
      '{plan} insurance is not available for children. You may cover a spouse or partner.',
    coverage_disclaimer_spouses_and_children: 'Generally, kids may be covered until age {maxAge}.',
    cost_varies_label: 'Cost varies',
    coverage_disclaimer_available_to_partners_only:
      '{plan} insurance is not available for a spouse or partner. You may cover children until age {maxAge}.',
    coverage_disclaimer_available_to_children_only:
      '{plan} insurance is not available for a spouse or children. You may cover a partner.',
  },
};
